import { Switch, SwitchProps } from '@headlessui/react';
import { forwardRef } from 'react';
import cn from 'classnames';

export type SwitchSize = 'xs' | 'sm' | 'md' | 'lg';

const sizes: {
  [key in SwitchSize]: {
    container: string;
    switch: string;
    translate: string;
  };
} = {
  xs: {
    switch: 'h-2.5 w-2.5',
    translate: 'translate-x-2.5',
    container: 'w-6 h-3.5',
  },
  sm: {
    switch: 'h-3.5 w-3.5',
    translate: 'translate-x-[0.85rem]',
    container: 'h-4.5 w-8',
  },
  md: {
    switch: 'h-4 w-4',
    translate: 'translate-x-3',
    container: 'h-5 w-8',
  },
  lg: {
    switch: 'h-4 w-4',
    translate: 'translate-x-3',
    container: 'h-5 w-8',
  },
};

interface IControlledSwitchProps
  extends Omit<SwitchProps<'button'>, 'value' | 'size'> {
  onChange: (val: boolean) => void;
  value: boolean;
  size?: SwitchSize;
  className?: string;
}

export const ControlledSwitch = forwardRef<
  HTMLButtonElement,
  IControlledSwitchProps
>(({ onChange, value, size = 'md', className = 'ml-auto' }, ref) => {
  const handleChange = (isChecked: boolean) => {
    onChange(isChecked);
  };

  return (
    <div className={cn('flex items-center', className)}>
      <Switch
        as="span"
        ref={ref}
        checked={value}
        onChange={handleChange}
        onKeyDown={(ev) => {
          if (ev.key === 'Enter') {
            handleChange(!value);
          }
        }}
        className={`${value ? 'bg-primary-dark' : 'bg-grey-200'}
relative inline-flex shrink-0 ${
          sizes[size].container
        } cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span
          aria-hidden="true"
          className={`${value ? sizes[size].translate : 'translate-x-0'}
pointer-events-none inline-block ${
            sizes[size].switch
          } transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
});

export default ControlledSwitch;
